import { render, staticRenderFns } from "./process.vue?vue&type=template&id=1d67fb4a&"
import script from "./process.vue?vue&type=script&lang=ts&"
export * from "./process.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "process.vue"
export default component.exports